export default __webpack_public_path__ + "static/6-f99e50d7b951b8cd249ee35f071d7db0.jpg";